export default __webpack_public_path__ + "static/location-83ca9ec82620eab8a0849b9ce76cb5ba.jpg";